export const apiUrl = process.env.NEXT_PUBLIC_API_URL;
export const modoLocal = process.env.NEXT_PUBLIC_MODO_LOCAL;
export const loginPath = process.env.NEXT_PUBLIC_LOGIN_PATH;
export const mercadoPagoPublicKey = window.__CONFIG__.mercadoPagoPublicKey;
export const mercadoPagoApiUrl = window.__CONFIG__.apiMercadoPago;
export const mercadoPagoApiCri = process.env.NEXT_PUBLIC_API_MERCADOPAGO_CRI;
export const mercadoPagoConsultaUrl = process.env.NEXT_PUBLIC_CONSULTA_PAGO;
export const mercadoPagoCreacionUrl = process.env.NEXT_PUBLIC_CREACION_PAGO;
export const mercadoPagoProcesamientoUrl = process.env.NEXT_PUBLIC_PROCESO_PAGO;